import React, { useState } from "react";
import logo from "../../images/white-orchide.png";
import { Link, NavLink } from "react-router-dom";
import "./Header.scss";
import { useAuthStore } from "../../stores/authStore";
import { useCart } from "../../hooks/useCartQueries";
import { ShoppingCart, Menu, ChevronDown, LogIn } from "lucide-react";
import { hasRole } from "../../config/roles";

const Header = () => {
  const [mobMenuOpened, setMobMenuOpened] = useState(false);

  const { userInfo, logout } = useAuthStore();
  const { data: cart } = useCart();
  const itemCount = cart?.itemCount ?? 0;

  const toggleMenu = () => {
    setMobMenuOpened(!mobMenuOpened);
  };

  const closeMenu = () => {
    if (mobMenuOpened) {
      setMobMenuOpened(false);
    }
  };

  const logoutHandler = (e) => {
    e.preventDefault();
    logout();
  };

  const authBarHandler = () => {
    if (userInfo) {
      return (
        <React.Fragment>
          <li className="aks-dropdown">
            <span className="dropdown-title">
              {userInfo.name} <ChevronDown className="size-3 inline ml-1" />
            </span>

            <ul className="dropdown-items">
              <li>
                <Link to={"/account/settings"}>Account Settings</Link>
              </li>
              {hasRole(userInfo?.role, "admin") && (
                <li>
                  <Link to={"/settings"}>App Settings</Link>
                </li>
              )}
              <li>
                <a href="/" onClick={logoutHandler}>
                  Logout
                </a>
              </li>
            </ul>
          </li>
        </React.Fragment>
      );
    } else {
      return (
        <li>
          <Link to={"/account/login"}>
            Login <LogIn className="size-3.5 inline ml-1" />
          </Link>
        </li>
      );
    }
  };

  return (
    <menu>
      <div className="container">
        <div className="row">
          <div className="col-lg-2 col-md-4 col-8 self-center">
            <Link to={"/"}>
              <img src={logo} alt="White Orchide Logo" className="img-fluid logo" />
            </Link>
          </div>
          <div className="col-lg-10 col-md-8 col-4 self-center menu-right-part">
            {!userInfo ? (
              <NavLink className="login-lnk" to={"/account/login"}>
                Login <LogIn className="size-3.5 inline ml-1" />
              </NavLink>
            ) : (
              <React.Fragment>
                {/* Mobile icons: Cart and Menu */}
                <div className="hidden max-lg:flex items-center justify-end gap-5">
                  {hasRole(userInfo?.role, "user") && (
                    <Link
                      to="/cart"
                      className="relative text-white opacity-70 hover:opacity-100 transition-opacity"
                    >
                      <ShoppingCart className="size-5" />
                      {itemCount > 0 && (
                        <span className="absolute -top-2 -right-2.5 bg-primary text-white text-[10px] font-semibold min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1">
                          {itemCount > 99 ? "99+" : itemCount}
                        </span>
                      )}
                    </Link>
                  )}
                  <button
                    className="text-white opacity-70 hover:opacity-100 transition-opacity"
                    onClick={toggleMenu}
                  >
                    <Menu className="size-5" />
                  </button>
                </div>

                <div className={`menu-wrapper ${mobMenuOpened ? "mob-menu-opened" : ""}`}>
                  <img
                    src={logo}
                    alt="White Orchide Logo"
                    className="mob-logo only-mob img-fluid"
                  />

                  <ul className="navigation-links navigation-list" onClick={closeMenu}>
                    {hasRole(userInfo?.role, "admin") && (
                      <React.Fragment>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/analytics"}
                          >
                            Analytics
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/branches"}
                          >
                            Branches
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/categories"}
                          >
                            Categories
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/products"}
                          >
                            Products
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/account"}
                          >
                            Accounts
                          </NavLink>
                        </li>
                      </React.Fragment>
                    )}
                    {hasRole(userInfo?.role, "user") && (
                      <React.Fragment>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/orders"}
                          >
                            Orders
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className={({ isActive }) => (isActive ? "active" : "")}
                            to={"/shop"}
                          >
                            Shop
                          </NavLink>
                        </li>
                      </React.Fragment>
                    )}
                  </ul>
                  <ul className="navigation-icons navigation-list" onClick={closeMenu}>
                    {hasRole(userInfo?.role, "user") && (
                      <li className="relative">
                        <NavLink to={"/cart"}>
                          <ShoppingCart className="size-3.5 inline ml-1" />
                        </NavLink>
                        {itemCount > 0 && (
                          <span className="absolute -top-0.5 right-1 bg-primary text-white text-[10px] font-semibold min-w-[16px] h-[16px] rounded-full inline-flex items-center justify-center px-1 pointer-events-none">
                            {itemCount > 99 ? "99+" : itemCount}
                          </span>
                        )}
                      </li>
                    )}
                    {authBarHandler()}
                  </ul>

                  <div className="only-mob menu-close" onClick={closeMenu}>
                    Close Menu
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </menu>
  );
};

export default Header;
